const colorPallete = {
  blue: '#658DFE',
  red: '#ff6167',
  green: '#99FF99',
  yellow: '#FCD859',
  black: '#000',
  white: '#fff'
}
const getColor = color => {
  if(color) {
    return colorPallete[color];
  }

  return colorPallete.black;
}

const shuffle = (a) => {
  var j, x, i;
	for (i = a.length - 1; i > 0; i--) {
		j = Math.floor(Math.random() * (i + 1));
		x = a[i];
		a[i] = a[j];
		a[j] = x;
  }

	return a;
}

const randomColor = () => {
  const pallete = colorPallete;

  const keys = Object.keys(pallete);
  delete keys[4];
  delete keys[5];

  return pallete[keys[ keys.length * Math.random() << 0]];
}

export { getColor, randomColor, shuffle };
